var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IncentivesPeriodColumn_1;
/* eslint-disable import/no-duplicates */
import '@symon-ai/wisepipe-base-pipe'; // force import for JsonSchema
import { ColumnTypeEnum } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
const schema = {
    $id: 'urn:wisepipe-common-pipe:IncentivesPeriodColumn',
    type: 'object',
    properties: {
        sourceColumnName: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable'
                },
                { type: 'string', minLength: 1, maxLength: 150 }
            ]
        },
        sourceColumnType: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:EnumToolVariable'
                },
                { type: 'string', pattern: `${ColumnTypeEnum.date}|${ColumnTypeEnum.period}` }
            ]
        },
        newColumnName: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:StringToolVariable'
                },
                { type: 'string', minLength: 1, maxLength: 150 }
            ]
        },
        targetCalendarID: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:CalendarToolVariable'
                },
                { type: 'string', minLength: 1 }
            ]
        },
        targetPeriodLevel: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:CalendarToolVariable'
                },
                { type: 'string', minLength: 1 }
            ]
        }
    },
    required: ['sourceColumnName', 'sourceColumnType', 'newColumnName', 'targetCalendarID', 'targetPeriodLevel']
};
let IncentivesPeriodColumn = IncentivesPeriodColumn_1 = class IncentivesPeriodColumn {
    constructor(sourceColumnName, sourceColumnType, newColumnName, targetCalendarID, targetPeriodLevel) {
        this.sourceColumnName = sourceColumnName;
        this.sourceColumnType = sourceColumnType;
        this.newColumnName = newColumnName;
        this.targetCalendarID = targetCalendarID;
        this.targetPeriodLevel = targetPeriodLevel;
        JSON.validate(this, IncentivesPeriodColumn_1);
    }
    applyParameters(parameters) {
        const baseVals = this.getBaseValues(parameters);
        return new IncentivesPeriodColumn_1(baseVals.sourceColumnName, baseVals.sourceColumnType, baseVals.newColumnName, baseVals.targetCalendarID, baseVals.targetPeriodLevel);
    }
    getBaseValues(parameters) {
        return {
            sourceColumnName: parameters.getStrVal(this.sourceColumnName),
            // sourceColumnType is actually columnType, but we leave it as a string for backwards compat
            sourceColumnType: parameters.getStrVal(this.sourceColumnType),
            newColumnName: parameters.getStrVal(this.newColumnName),
            targetCalendarID: parameters.getCalIDVal(this.targetCalendarID),
            targetPeriodLevel: parameters.getCalLevelVal(this.targetPeriodLevel)
        };
    }
};
IncentivesPeriodColumn = IncentivesPeriodColumn_1 = __decorate([
    JsonSchema(schema)
], IncentivesPeriodColumn);
export { IncentivesPeriodColumn };
//# sourceMappingURL=incentivesPeriodColumn.js.map